import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import env from '../env';

const postApi = createApi({
    reducerPath: 'post',
    baseQuery: fetchBaseQuery({
        baseUrl: env.baseUrl,
        prepareHeaders: (headers, { getState }) => {

            const token = getState().environment.token;

            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }

            return headers
        }
    }),
    tagTypes: ['Posts'],
    endpoints(builder) {
        return {
            getPost: builder.query({
                query: (id) => {
                    return {
                        url: `/posts/${id}`,
                        method: 'GET',
                    };
                },
                providesTags: (post) => [{ type: 'Posts', id: post.id }],
                transformResponse: (post) => {

                    if (post.creationDate) {
                        post.creationDate = post.creationDate.substring(0, 10);
                    }

                    return post;
                },
            }),
            updatePost: builder.mutation({
                query(post) {
                    return {
                        url: `/posts/${post.id}`,
                        method: 'PUT',
                        body: post
                    }
                },
                invalidatesTags: (_result, _error, post) => [{ type: 'Posts', id: post.id }],
            }),
            deletePost: builder.mutation({
                query(post) {

                    return {
                        url: `/posts/${post.id}`,
                        method: 'DELETE'
                    }
                },
                invalidatesTags: (_result, _error, post) => [{ type: 'Posts', id: post.id }]
            }),
        };
    }
});

export const {
    useGetPostQuery,
    useUpdatePostMutation,
    useDeletePostMutation
} = postApi;
export { postApi };
